import React, { useState, useEffect } from "react";
import {
  PieChart,
  Pie,
  Tooltip,
  Legend,
  Cell,
  ResponsiveContainer,
} from "recharts";
import "./Departofficolpagesss.css";
import {
  departmentOfficeData,
  officerWiseData,
  getDepartmentDetails,
} from "../../../api/collectorApi";
import { useTranslation } from "react-i18next";
export default function Departofficolpagesss() {
  const COLORS = ["#00BCD4", "#ff9800"];

  /* ---------------- Hover + Popup Data ---------------- */
 
const { t } = useTranslation();
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [hoverInfo, setHoverInfo] = useState(null);
const [popupDept, setPopupDept] = useState(null);
const [deptDetails, setDeptDetails] = useState([]);
const [loadingDetails, setLoadingDetails] = useState(false);
const [selectedGrievance, setSelectedGrievance] = useState(null);



  /* ---------------- Officer Data ---------------- */
  const [officerData, setOfficerData] = useState({});
  const [officerList, setOfficerList] = useState([]);
  const [loadingOfficer, setLoadingOfficer] = useState(true);
  const [selectedOfficer, setSelectedOfficer] = useState("");

  useEffect(() => {
    const fetchOfficer = async () => {
      try {
        setLoadingOfficer(true);
        const data = await officerWiseData();
        const safe = Array.isArray(data) ? data : [];

        const chartData = {};
        const list = safe.map((o) => {
          const resolved = Number(o.resolved ?? 0);
          const pending = Number(o.pending ?? o.inProgress ?? 0);

        chartData[o.officerId] = [
  { name: t("analytics.resolved"), value: resolved },
  { name: t("analytics.pending"), value: pending },
];
          return {
            officerId: o.officerId,
            name: o.name,
            designation: o.designation,
          };
        });

        setOfficerData(chartData);
        setOfficerList(list);

        if (!selectedOfficer && list.length > 0) {
          setSelectedOfficer(list[0].officerId);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingOfficer(false);
      }
    };

    fetchOfficer();
  }, []);

  /* ---------------- Department Data ---------------- */
  const [departmentData, setDepartmentData] = useState([]);
  const [loadingDept, setLoadingDept] = useState(true);

  useEffect(() => {
    const fetchDept = async () => {
      try {
        setLoadingDept(true);
        const data = await departmentOfficeData();
        const safe = Array.isArray(data) ? data : [];

       setDepartmentData(
  safe.map((d) => ({
    departmentId: d.departmentId,
    name: d.department,
    resolved: Number(d.resolved ?? 0),
    pending: Number(d.pending ?? 0),
  }))
);

      } catch (e) {
        console.error(e);
      } finally {
        setLoadingDept(false);
      }
    };

    fetchDept();
  }, []);


  const currentOfficerChart = officerData[selectedOfficer] ?? [];
  const totalCases = currentOfficerChart.reduce(
    (s, d) => s + d.value,
    0
  );
const handlePendingClick = async (dept) => {
  try {
    setPopupDept(dept);
    setLoadingDetails(true);
    setDeptDetails([]);

    const grievances = await getDepartmentDetails(dept.departmentId);

    setDeptDetails(grievances); // ✅ ONLY grievances
  } catch (error) {
    console.error("Popup API error:", error);
    setDeptDetails([]);
  } finally {
    setLoadingDetails(false);
  }
};




  return (
    <div className="departofficolpagesss-container">
    <h2 className="departofficolpagesss-title">
  {t("analytics.title")}
</h2>

      <div className="departofficolpagesss-cardcontainer">
        {/* ================= Department Card ================= */}
        <div
          className="departofficolpagesss-card"
          onMouseMove={(e) =>
            setMousePos({ x: e.clientX, y: e.clientY })
          }
        >
        <h3 className="departofficolpagesss-subtitle">
  {t("analytics.departmentCaseLoad")}
</h3>

          {loadingDept ? (
           <p>{t("common.loading")}</p>
          ) : (
            departmentData.map((dept, i) => {
              const total = dept.resolved + dept.pending || 1;

              return (
                <div key={i} className="departofficolpagesss-barwrapper">
   <div className="departofficolpagesss-deptname">
  {dept.name}
</div>
                  <div className="departofficolpagesss-bar">
                    <div
                      className="departofficolpagesss-barfill resolved"
                      style={{
                        width: `${(dept.resolved / total) * 100}%`,
                      }}
                    />

                    <div
                      className="departofficolpagesss-barfill pending"
                      style={{
                        width: `${(dept.pending / total) * 100}%`,
                      }}
                    onMouseEnter={() =>
  setHoverInfo({
    dept: dept.name,
    pending: dept.pending,
    total: dept.resolved + dept.pending,
  })
}
onMouseLeave={() => setHoverInfo(null)}

                     onClick={() => handlePendingClick(dept)}

                    />
                  </div>
                </div>
              );
            })
          )}

          {/* ---------- Hover Tooltip ---------- */}
          {hoverInfo && (
            <div
              className="hover-tooltip"
              style={{
                top: mousePos.y + 12,
                left: mousePos.x + 12,
              }}
            >
             <strong>{hoverInfo.dept}</strong>
<br />
{t("analytics.pending")}: {hoverInfo.pending}
<br />
{t("analytics.total")}: {hoverInfo.total}
            </div>
          )}
        </div>

       <div className="departofficolpagesss-card"> 
<div className="departofficolpagesss-header"> 
<h3 className="departofficolpagesss-subtitle">
  {t("analytics.officerPerformance")}
</h3>
<div className="scroll-wrapper"> 
<select 
className="departofficolpagesss-dropdown scroll-select" 
value={selectedOfficer} 
onChange={(e) => setSelectedOfficer(e.target.value)} 
> 
<option value="">
  {t("analytics.selectOfficer")}
</option>
{loadingOfficer ? ( 
<option>{t("common.loading")}</option>
) : officerList.length === 0 ? ( 
<option>{t("analytics.noOfficers")}</option>
) : ( 
officerList.map((o) => ( 
<option key={o.officerId} value={o.officerId}> 
{o.name} ({o.designation}) 
</option> 
)) 
)} 
</select> 
</div> 
</div> 
<div className="departofficolpagesss-chart"> 
<ResponsiveContainer width="100%" height={250}> 
<PieChart> 
<Tooltip /> 
<Legend verticalAlign="bottom" height={30} /> 
{currentOfficerChart && ( 
<Pie 
data={currentOfficerChart} 
innerRadius={50} 
outerRadius={80} 
paddingAngle={5} 
dataKey="value" 
labelLine={false} 
> 
{currentOfficerChart.map((entry, index) => ( 
<Cell key={index} fill={COLORS[index % COLORS.length]} /> 
))} 
</Pie> 
)} 
</PieChart> 
</ResponsiveContainer> 
</div> 
<div className="departofficolpagesss-summary"> 
<p>
  {t("analytics.totalCases")}:
  <strong>{totalCases}</strong>
</p>
{currentOfficerChart && 
currentOfficerChart.map((d, i) => ( 
<p key={i}> 
{d.name}: <strong>{d.value}</strong> 
</p> 
))} 
</div> 
<p className="departofficolpagesss-caption">
  {t("analytics.avgResolutionTime")} (
  {officerList.find((o) => o.officerId === selectedOfficer)?.name || ""}
  )
</p>
</div> 
</div> 
    {popupDept && (
  <div className="pcm-overlay" onClick={() => setPopupDept(null)}>
    <div className="pcm-modal" onClick={(e) => e.stopPropagation()}>
     <h2 className="pcm-title">
  {popupDept.name} – {t("analytics.pendingGrievances")}
</h2>

      {loadingDetails ? (
       <p>{t("analytics.loadingDetails")}</p>

      ) : deptDetails.length === 0 ? (
       <p>{t("analytics.noPendingFound")}</p>
      ) : (
        <>


          {/* ---------- Grievance List ---------- */}
       <div className="pcm-list">
  {deptDetails.map((item, index) => (
    <div
      key={index}
      className="pcm-row"
      onClick={() => setSelectedGrievance(item)} //  OPEN SECOND POPUP
    >
      <div className="pcm-col id">{item.grievanceId}</div>
      <div className="pcm-col desc">{item.description}</div>
      <div className={`pcm-col status ${item.status}`}>
        {item.status}
      </div>
    </div>
  ))}
</div>
{selectedGrievance && (
  <div
    className="pcm-overlay"
    onClick={() => setSelectedGrievance(null)}
  >
    <div
      className="pcm-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <h2 className="pcm-title">
  {t("analytics.grievanceDetails")}
</h2>

      <div className="pcm-item">
        <p><strong>{t("analytics.grievanceNo")}:</strong> {selectedGrievance.grievanceId}</p>
        <p><strong>{t("analytics.status")}:</strong> {selectedGrievance.status}</p>
        <p><strong>{t("analytics.priority")}:</strong> {selectedGrievance.priority}</p>
        <p><strong>{t("analytics.category")}:</strong> {selectedGrievance.category}</p>
        <p><strong>{t("analytics.description")}:</strong> {selectedGrievance.description}</p>

        <p>
          <strong>{t("analytics.citizen")}:</strong>{" "}
          {selectedGrievance.citizen?.name || "N/A"}
        </p>

        <p>
          <strong>{t("analytics.assignedOfficer")}:</strong>{" "}
          {selectedGrievance.assignedOfficer?.name} (
          {selectedGrievance.assignedOfficer?.designation})
        </p>

        <p>
          <strong>{t("analytics.createdAt")}:</strong>{" "}
          {new Date(selectedGrievance.createdAt).toLocaleString()}
        </p>
      </div>

    <button className="pcm-close-btn">
  {t("common.close")}
</button>
    </div>
  </div>
)}

        </>
      )}

      <button
        className="pcm-close-btn"
        onClick={() => setPopupDept(null)}
      >
  {t("common.close")}
      </button>
    </div>
  </div>
)}


    </div>
  );
}


